import { useState } from 'react';

function Competitors({ onComplete }) {
  const [competitors, setCompetitors] = useState([]);
  const [newCompetitor, setNewCompetitor] = useState('');

  const handleAddCompetitor = () => {
    if (newCompetitor.trim()) {
      setCompetitors(prev => [...prev, {
        name: newCompetitor.trim(),
        url: `https://${newCompetitor.trim().toLowerCase().replace(/\s+/g, '')}.com`
      }]);
      setNewCompetitor('');
      onComplete(true);
    }
  };

  const handleRemoveCompetitor = (index) => {
    setCompetitors(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="flex items-center space-x-2 mb-6">
        <span className="text-red-500">🎯</span>
        <h2 className="text-lg font-medium">Competitors</h2>
      </div>
      <p className="text-sm text-gray-600 mb-6">
        Identify your brand's main competitors.
      </p>

      <div className="space-y-6">
        <div className="flex">
          <input
            type="text"
            value={newCompetitor}
            onChange={(e) => setNewCompetitor(e.target.value)}
            placeholder="Search by name"
            className="flex-1 rounded-l-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
          <button
            onClick={handleAddCompetitor}
            className="px-4 py-2 bg-[#0049ac] text-white rounded-r-lg hover:bg-[#0049ac]/90"
          >
            Add
          </button>
        </div>

        <div className="flex flex-wrap gap-2">
          {competitors.map((competitor, index) => (
            <div
              key={index}
              className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800"
            >
              <img
                src={`https://www.google.com/s2/favicons?domain=${competitor.url}`}
                alt=""
                className="h-4 w-4 mr-2"
              />
              {competitor.name}
              <button
                onClick={() => handleRemoveCompetitor(index)}
                className="ml-2 inline-flex items-center justify-center h-4 w-4 rounded-full hover:bg-purple-200"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Competitors;